'use client';

import { c as _c } from "react/compiler-runtime";
import { type FactiiiTag } from '@shared/all/domains/factiiis';
import { convertToFactiiiTag } from '@shared/utils/helpers/formatNumbers';
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import { useQuery } from '@tanstack/react-query';
import { Loader, Search } from 'lucide-react';
import { useState } from 'react';
import { useInstanceSpaceSlug } from '../../../hooks/useInstanceSpaceSlug';
import { client } from '../../../utils/trpc';
import Input from '../../UI/Input';
import { FactiiiSearchResult } from '../FactiiiSearchResult';
type Props = {
  myPostFactiiiCounts: FactiiiTag[];
  handleClick: (tag: FactiiiTag) => void;
};
export const BotFactiii = t0 => {
  const $ = _c(34);
  const {
    myPostFactiiiCounts,
    handleClick
  } = t0;
  const [searchQuery, setSearchQuery] = useState("");
  const preferSpaceSlug = useInstanceSpaceSlug();
  let t1;
  if ($[0] !== preferSpaceSlug || $[1] !== searchQuery) {
    t1 = ["searchBotFactiiis", searchQuery, preferSpaceSlug];
    $[0] = preferSpaceSlug;
    $[1] = searchQuery;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== myPostFactiiiCounts || $[4] !== preferSpaceSlug || $[5] !== searchQuery) {
    t2 = () => unwrapFromResult(client.search.factiiis.query({
      query: searchQuery,
      preferSpaceSlug,
      botsOnly: true,
      ignoredIds: myPostFactiiiCounts.map(_temp)
    }));
    $[3] = myPostFactiiiCounts;
    $[4] = preferSpaceSlug;
    $[5] = searchQuery;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = {
      queryKey: t1,
      queryFn: t2,
      refetchOnWindowFocus: false,
      placeholderData: _temp2,
      staleTime: 30000
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const {
    data: searchResults,
    isLoading: searchLoading
  } = useQuery(t3);
  let t4;
  if ($[10] !== searchLoading) {
    t4 = [searchLoading ? <Loader key="loading-icon" className="animate-spin" /> : <Search key="search-icon" />];
    $[10] = searchLoading;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== searchQuery || $[13] !== t4) {
    t5 = <Input autofocus={true} value={searchQuery} onChange={setSearchQuery} placeholder="Search for bots..." icons={t4} />;
    $[12] = searchQuery;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== searchLoading) {
    t6 = searchLoading && <div className="flex items-center justify-center py-4"><Loader className="animate-spin text-textSecondary" /></div>;
    $[15] = searchLoading;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== handleClick || $[18] !== myPostFactiiiCounts || $[19] !== searchLoading || $[20] !== searchQuery || $[21] !== searchResults?.factiiis) {
    bb0: {
      let t8;
      if ($[23] !== myPostFactiiiCounts) {
        t8 = new Set(myPostFactiiiCounts.map(_temp3));
        $[23] = myPostFactiiiCounts;
        $[24] = t8;
      } else {
        t8 = $[24];
      }
      const selectedIds = t8;
      const filtered = searchResults?.factiiis?.filter(f => !selectedIds.has(f.id)) ?? [];
      if (filtered.length > 0) {
        let t9;
        if ($[25] !== handleClick) {
          t9 = factiii => <FactiiiSearchResult key={factiii.id} tag={convertToFactiiiTag(factiii)} replyConfig={factiii.replyConfig} handleClick={() => handleClick(convertToFactiiiTag(factiii))} />;
          $[25] = handleClick;
          $[26] = t9;
        } else {
          t9 = $[26];
        }
        t7 = filtered.map(t9);
        break bb0;
      }
      if (!searchLoading && searchQuery.length > 0) {
        let t9;
        if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
          t9 = <p className="py-4 text-center text-sm text-textSecondary">No bot factiiis found.</p>;
          $[27] = t9;
        } else {
          t9 = $[27];
        }
        t7 = t9;
        break bb0;
      }
      t7 = null;
    }
    $[17] = handleClick;
    $[18] = myPostFactiiiCounts;
    $[19] = searchLoading;
    $[20] = searchQuery;
    $[21] = searchResults?.factiiis;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[28] !== t6 || $[29] !== t7) {
    t8 = <div className="mt-3 space-y-3">{t6}{t7}</div>;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== t5 || $[32] !== t8) {
    t9 = <div className="flex flex-col">{t5}{t8}</div>;
    $[31] = t5;
    $[32] = t8;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  return t9;
};
function _temp(bot) {
  return bot.factiiiId;
}
function _temp2(previousData) {
  return previousData;
}
function _temp3(t) {
  return t.factiiiId;
}